import type { HTMLAttributes, ReactNode } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import css from './context-menu.module.scss';

type ContextMenuProps = HTMLAttributes<HTMLDivElement>;

export const ContextMenu = ({
  className,
  children,
  ...restProps
}: ContextMenuProps) => (
  <div className={joinCss(css.menu, className)} {...restProps}>
    {children}
  </div>
);

type MenuItemProps = HTMLAttributes<HTMLDivElement> & {
  icon?: ReactNode;
  destructive?: boolean;
};

export const MenuItem = ({
  icon,
  destructive = false,
  className,
  children,
  ...restProps
}: MenuItemProps) => (
  <div
    className={joinCss(css.item, destructive && css.isDestructive, className)}
    {...restProps}
  >
    {icon && <span className={css.itemIcon}>{icon}</span>}
    {children}
  </div>
);
